import type { StoreLocator as StoreLocatorAdmin } from '@admin/features/store-locators/libs/type'
import type { Response } from '@frontend/libs/types/common'
import type { Post, SinglePost } from '@frontend/libs/types/post'
import type { ErrorResponse } from '@shared/types/http'

import { endpoint } from '@shared/services/endpoint'
import { getRequest } from '@shared/services/fetcher'
import useSWR from 'swr'

export type StoreLocator = Omit<StoreLocatorAdmin, 'createdAt' | 'updatedAt'>

export type GetLookBookResponse = Response<Post[]>
export type GetLookBookBySlugResponse = Response<SinglePost>

export function useStoreLocator() {
  const useGetAll = () => {
    return useSWR<StoreLocator[], Error>(
      `${endpoint.frontend.STORE_LOCATORS}`,
      getRequest,
    )
  }

  const useGetBySlug = (slug: string) => {
    return useSWR<StoreLocator, ErrorResponse>(
      `${endpoint.frontend.STORE_LOCATORS}/${slug}`,
      getRequest,
    )
  }

  return { getAll: useGetAll, getBySlug: useGetBySlug }
}
